module.exports = __webpack_public_path__ + "img/video-appointment.3b436916.png";